function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';

// @todo. auto generated. fix this error
// @ts-ignore
const stripePromise = loadStripe(webpack_stripe_key);
export class StripeElementsConsumer extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "renderChildrenWithStripe", (stripe, elements) => {
      const {
        children
      } = this.props;

      // only one card element allowed on the page
      if (!React.Children.only(children)) {
        return null;
      }
      if (! /*#__PURE__*/React.isValidElement(children)) {
        return null;
      }
      return /*#__PURE__*/React.cloneElement(children, {
        stripe,
        elements
      });
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(ElementsConsumer, null, ({
      stripe,
      elements
    }) => {
      return this.renderChildrenWithStripe(stripe, elements);
    });
  }
}
export class StripeElementsProvider extends React.Component {
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/React.createElement(Elements, {
      stripe: stripePromise
    }, children);
  }
}
export default class StripeElementsContext extends React.Component {
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/React.createElement(StripeElementsProvider, null, /*#__PURE__*/React.createElement(StripeElementsConsumer, null, children));
  }
}